<template>
    <div>
        <b-form-group :label="hideLabel ? '' : $t('talk.' + type)">
            <multiselect-color
                :id="`${type}-multiselect`"
                :options="usersOptions"
                :placeholder="placeholder"
                :state="state"
                :loading="loading"
                :selected="selected"
                :clearOnSelect="clearOnSelect"
                :closeOnSelect="closeOnSelect"
                :searchable="searchable"
                :multiple="multiple"
                :hideSelected="hideSelected"
                @changeValue="onChangedHandler"
                @changeSearch="debouncedSearchHandler"
                :no-elements-found="$t('form.multiselect.noUserWasFound')"
            />
        </b-form-group>
    </div>
</template>

<script>
import i18n from '@/i18n'
import { mapperToOptions } from '@/views/components/selects/select-with-avatar'
import { MultiselectColor } from '@/views/components/selects'

import { getUsers } from '../api'

import { debounce } from 'lodash'

export default {
    name: 'UsersSelect',
    components: {
        MultiselectColor,
    },
    props: {
        color: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        clearOnSelect: {
            type: Boolean,
            default: false,
        },
        closeOnSelect: {
            type: Boolean,
            default: false,
        },
        state: {
            default: null,
            type: Boolean | null,
        },
        placeholder: {
            default: i18n.t('people.select') + '...',
            type: String,
        },
        searchable: {
            default: true,
            type: Boolean,
        },
        hideSelected: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            selected: [],
            debouncedSearchHandler: null,
            search: '',
            previousSearch: null,
            users: [],
            loading: false,
            pagination: {
                perPage: 10,
                page: 1,
            },
        }
    },
    created() {
        this.debouncedSearchHandler = debounce(this.searchHandler, 1000)
    },
    mounted() {
        this.getUsers()
    },
    methods: {
        getUsers() {
            this.loading = true

            this.resetPaginationIfNewSearch()

            const params = {
                per_page: this.pagination.perPage,
                page: this.pagination.page,
                search: `name:${this.search.trim() || ''}`,
            }
            getUsers(params)
                .then(resp => {
                    const { current_page, data } = resp
                    this.pagination.page = current_page
                    this.users = data

                    this.previousSearch = this.search
                })
                .finally(() => {
                    this.loading = false
                })
        },
        searchHandler(search) {
            this.search = search
            this.getUsers()
        },

        resetPaginationIfNewSearch() {
            if (this.previousSearch === this.search) {
                return
            }
            this.pagination.page = 1
        },
        onChangedHandler(event) {
            this.$emit('changed', event)
        },
    },
    computed: {
        usersOptions() {
            if (this.previousSearch !== this.search) {
                return []
            }
            return mapperToOptions(this.users).map(option => {
                return { ...option, color: { hex: this.color } }
            })
        },
    },
}
</script>
